function ProjectsNavigation() {
    return (
        <>
            <div className="aboutMeProjects">
                <div className="container max-w-screen-sm mx-auto py-12 flex flex-col justify-center items-center">
                    <h2 className="font-bold text-red-500 uppercase">projects</h2>
                    <h1 className="font-bold text-2xl text-center">Projects navigation</h1>
                    <hr className="border-b-2 w-48 my-3 text-center" />
                        <p className="text-center my-3 px-4">I don't just create websites. Besides that I do graphics, 3D models,
                            music, games and various software.</p>
                        <ul className="flex flex-col w-full">
                            <ul className="flex justify-between space-x-4 w-full px-4 max-sm:flex-col max-sm:space-x-0 max-sm:pb-4">
                                <li className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center w-1/3 max-sm:w-full">
                                    <a href="#websitesProjects" className="hover:underline">Websites</a>
                                </li>
                                <li className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center w-1/3 max-sm:w-full">
                                    <a href="#softwareProjects" className="hover:underline">Software</a>
                                </li>
                                <li className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center w-1/3 max-sm:w-full max-sm:mb-0">
                                    <a href="#3dmodelsProjects" className="hover:underline">3D Models</a>
                                </li>
                            </ul>
                            <ul className="flex justify-between space-x-4 w-full px-4 max-sm:flex-col max-sm:space-x-0">
                                <li className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center w-1/3 max-sm:w-full">
                                    <a href="#graphicdesignProjects" className="hover:underline">Graphic Design</a>
                                </li>
                                <li className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center w-1/3 max-sm:w-full">
                                    <a href="#gamesProjects" className="hover:underline">Games</a>
                                </li>
                                <li className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center w-1/3 max-sm:w-full">
                                    <a href="#illustrationProjects" className="hover:underline">Illustration</a>
                                </li>
                            </ul>
                        </ul>
                </div>
            </div>
        </>
    );
}

export default ProjectsNavigation;